import React from "react";
import Select, {
  components,
  DropdownIndicatorProps,
  IndicatorSeparatorProps,
} from "react-select";
import { primaryColor } from "../../../../utility/constants/colorManager";
import { FiChevronDown } from "react-icons/fi";

const CustomSelect = ({
  value,
  onChange = () => {},
  placeholder = "Select ...",
  options = [],
  style,
  isSearchable = true,
  disabled = false,
  iconColor,
}) => {
  const indicatorSeparatorStyle = {
    alignSelf: "stretch",
    backgroundColor: "transparent",
    marginBottom: 8,
    marginTop: 8,
    width: 1,
  };

  const IndicatorSeparator = ({
    innerProps,
  }: IndicatorSeparatorProps<ColourOption, true>) => {
    return <span style={indicatorSeparatorStyle} {...innerProps} />;
  };

  const DropdownIndicator = (
    props: DropdownIndicatorProps<ColourOption, true>
  ) => {
    return (
      <components.DropdownIndicator {...props}>
        <FiChevronDown color={iconColor} size={20} style={{ marginRight: 5 }} />
      </components.DropdownIndicator>
    );
  };

  const styles = {
    option: (provided, state) => ({
      ...provided,
      fontFamily: "Open sans",
      color: state.isSelected ? "white" : "#7A7979",
      fontSize: state.selectProps.myFontSize,
      backgroundColor: state.isSelected ? "rgba(56, 54, 156, 0.8)" : "white",
      borderBottom: "1px solid #DFDFDF",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: "black",
      fontSize: state.selectProps.myFontSize,
    }),
    control: (baseStyles, state) => ({
      ...baseStyles,
      backgroundColor: "#F3F3F3",
      height: 55,
      borderRadius: 6,
      border: state.isFocused ? 0 : 0,
      boxShadow: state.isFocused ? 0 : 0,
      "&:hover": {
        border: state.isFocused ? 0 : 0,
      },
      ...style,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 999999999 }),
    menu: (base) => ({ ...base, zIndex: 99999 }),
  };
  return (
    <Select
      isDisabled={disabled}
      myFontSize="16px"
      options={options}
      styles={styles}
      placeholder={placeholder}
      components={{ DropdownIndicator, IndicatorSeparator }}
      value={value}
      onChange={onChange}
      isSearchable={isSearchable}
    />
  );
};

export default CustomSelect;
  